import "core-js/modules/es.array.push.js";
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/game/answer/triangle.png';
import _imports_1 from '@/assets/images/game/answer/exit.png';
import _imports_2 from '@/assets/images/game/answer/leftArrow.png';
import _imports_3 from '@/assets/images/game/answer/cardFace.png';
import _imports_4 from '@/assets/images/game/answer/cardReverse.png';
import _imports_5 from '@/assets/images/game/answer/rightArrow.png';
import _imports_6 from '@/assets/images/game/answer/clearance.png';
import _imports_7 from '@/assets/images/game/answer/rank.png';
import _imports_8 from '@/assets/images/game/answer/species.png';
import _imports_9 from '@/assets/images/game/answer/addIcon.png';
import _imports_10 from '@/assets/images/game/answer/goHome.png';
import _imports_11 from '@/assets/images/game/answer/nextLevel.png';
const _withScopeId = n => (_pushScopeId("data-v-fdc9d93c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "left"
};
const _hoisted_2 = {
  class: "describe"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "right"
};
const _hoisted_6 = {
  class: "television"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  class: "confirmButton"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "triangle"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  draggable: "false"
})], -1));
const _hoisted_11 = [_hoisted_10];
const _hoisted_12 = {
  class: "answer-footer"
};
const _hoisted_13 = {
  class: "answer-group"
};
const _hoisted_14 = ["onDragstart"];
const _hoisted_15 = {
  class: "answer-card-div"
};
const _hoisted_16 = ["onClick", "src"];
const _hoisted_17 = {
  class: "base"
};
const _hoisted_18 = ["src"];
const _hoisted_19 = {
  class: "carousel-box"
};
const _hoisted_20 = {
  class: "carousel-chart"
};
const _hoisted_21 = {
  class: "carousel"
};
const _hoisted_22 = {
  class: "content"
};
const _hoisted_23 = {
  key: 0,
  class: "front"
};
const _hoisted_24 = ["src"];
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "straight",
  src: _imports_3,
  alt: "",
  draggable: "false"
}, null, -1));
const _hoisted_26 = {
  key: 1,
  class: "front"
};
const _hoisted_27 = ["src"];
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "straight",
  src: _imports_3,
  alt: "",
  draggable: "false"
}, null, -1));
const _hoisted_29 = {
  class: "clearance"
};
const _hoisted_30 = {
  class: "clearance-center"
};
const _hoisted_31 = /*#__PURE__*/_createStaticVNode("<img class=\"clearance-img-top\" src=\"" + _imports_6 + "\" alt=\"\" draggable=\"false\" data-v-fdc9d93c><div class=\"rank-box\" data-v-fdc9d93c><img class=\"rank\" src=\"" + _imports_7 + "\" alt=\"\" draggable=\"false\" data-v-fdc9d93c><div class=\"rank-text\" data-v-fdc9d93c>20</div></div><div class=\"notice\" data-v-fdc9d93c>恭喜你的排名已经提升至第20名</div><div class=\"species-box\" data-v-fdc9d93c><img class=\"species\" src=\"" + _imports_8 + "\" alt=\"\" draggable=\"false\" data-v-fdc9d93c><img class=\"addIcon\" src=\"" + _imports_9 + "\" alt=\"\" draggable=\"false\" data-v-fdc9d93c><div class=\"species-text\" data-v-fdc9d93c>50</div></div>", 4);
const _hoisted_35 = {
  class: "footer-btn"
};
import { onMounted, ref, watch } from "vue";
export default {
  __name: 'answer',
  props: {
    handleGoHome: Function,
    setGoldCoin: Function,
    getLevel: Function,
    arrangeNum: Number,
    smallLevelIndex: Number,
    groupListName: String
  },
  setup(__props) {
    const props = __props;
    const currentIndex = ref(0);
    const images = ref([{}]);
    const indicate = ref(true);
    const carouselShow = ref(false);
    const subject = ref({
      title: '',
      // 添加默认值
      expound: '' // 添加默认值
    });

    const subjectTitle = ref('');
    const subjectTitleCopy = ref('');
    const subjectTitleAssistant = ref('');
    const answerCard = ref([]);
    const showCard = ref(0);
    const answerBeingDragged = ref(null);
    const droppedAnswer = ref(null);
    const dragCardIndexCopy = ref(null);
    const dragCardIndex = ref(null);
    const answerStatus = ref(null);
    const removeErrorCard = ref([]);
    const errorIndex = ref(null);
    const hideNext = ref(false);
    // 通关状态显示
    const clearanceShow = ref(false);
    const smallLevelIndexCopy = ref(0);
    watch(() => props.smallLevelIndex, newVal => {
      if (newVal) {
        smallLevelIndexCopy.value = props.smallLevelIndex === undefined ? 0 : props.smallLevelIndex === 12 ? 11 : props.smallLevelIndex;
      }
    }, {
      deep: true
    });
    watch(() => props.groupListName, newVal => {
      if (newVal) {
        hideNext.value = false;
        initialize(undefined);
      }
    }, {
      deep: true
    });
    watch(() => hideNext.value, newVal => {
      if (newVal) {}
    }, {
      deep: true
    });

    // 拖拽开始事件
    function onDragStart(answer, index) {
      answerBeingDragged.value = answer;
      // 选择错误后位置
      dragCardIndexCopy.value = index;
    }

    // 拖放事件
    function onDrop(event) {
      if (answerBeingDragged.value) {
        droppedAnswer.value = answerBeingDragged.value.name;
        answerBeingDragged.value = null;
        dragCardIndex.value = dragCardIndexCopy.value;
      }
      // 拖拽禁用打开预览
      event.preventDefault();
    }

    // 返回首页
    function goHome() {
      const levelList = JSON.parse(localStorage.getItem('levelList')) || [];
      const obj = getIndex(levelList, subjectTitle.value);
      levelList[obj.objectIndex].approve[obj.nameIndex] = true;
      localStorage.setItem('levelList', JSON.stringify(levelList));
      props.handleGoHome();
      answerStatus.value = null;
      dragCardIndex.value = null;
      droppedAnswer.value = null;
      clearanceShow.value = false;
      smallLevelIndexCopy.value = smallLevelIndexCopy.value !== 11 && smallLevelIndexCopy.value !== 0 ? smallLevelIndexCopy.value + 1 : 11;
    }

    // 下一关
    function nextLevel() {
      initialize(Math.floor(Math.random() * 100) + 1);
      answerStatus.value = null;
      dragCardIndex.value = null;
      droppedAnswer.value = null;
      clearanceShow.value = false;
      smallLevelIndexCopy.value = smallLevelIndexCopy.value !== 11 ? smallLevelIndexCopy.value + 1 : 11;
    }

    // 提交答案
    function handleConfirm() {
      if (droppedAnswer.value) {
        let daan = {};
        daan = answerCard.value[dragCardIndex.value];
        if (daan.correct !== undefined) {
          answerStatus.value = 0;
          const goldCoinNum = Number(localStorage.getItem('goldCoin')) + 50;
          localStorage.setItem('goldCoin', Number(goldCoinNum));
          props.setGoldCoin();
          setTimeout(() => {
            clearanceShow.value = true;
            // const list = JSON.parse(localStorage.getItem('levelList')) || [];
            // const obj = getIndex(list, subjectTitle.value);
            // localStorage.setItem('levelList', JSON.stringify(list));
            if (smallLevelIndexCopy.value === 11) {
              hideNext.value = true;
              initialize(undefined, 1);
            }
          }, 3000);
        } else {
          if (removeErrorCard.value.length === 0) {
            answerStatus.value = 2;
            errorIndex.value = null;
            droppedAnswer.value = null;
            dragCardIndex.value = -1;
            setTimeout(() => {
              answerStatus.value = null;
            }, 3000);
            return;
          }
          answerStatus.value = 1;
          // dragCardIndexCopy.value
          setTimeout(() => {
            answerStatus.value = null;
            dragCardIndex.value = null;
            droppedAnswer.value = null;
            answerCard.value.splice(dragCardIndexCopy.value, 1, removeErrorCard.value[0]);
            errorIndex.value = dragCardIndexCopy.value;
            removeErrorCard.value.splice(0, 1);
          }, 5000);
        }
      }
    }
    function getIndex(data, name) {
      for (let i = 0; i < data.length; i++) {
        const index = data[i].level.indexOf(name);
        if (index !== -1) {
          return {
            objectIndex: i,
            nameIndex: index
          };
        }
      }
      return {
        objectIndex: -1,
        nameIndex: -1
      }; // 返回 -1 表示未找到
    }

    // 初始化代码
    function initialize(below, data) {
      // 题目
      const subjectList = JSON.parse(localStorage.getItem('subjectList')) || [];
      // 小关卡index
      let levelListIndex = JSON.parse(localStorage.getItem('levelListIndex'));
      // 关卡的数组
      const levelList = JSON.parse(localStorage.getItem('levelList')) || [];
      // 关卡名称
      const storedSubjectTitle = localStorage.getItem('groupListName') || '';
      // 第几个小关
      const groupListIndex = Number(localStorage.getItem('groupListIndex')) || 0;
      // 关卡名称-复制
      subjectTitle.value = storedSubjectTitle;
      subjectTitleCopy.value = storedSubjectTitle.replace(/<br\/>/g, '').concat();
      subjectTitleAssistant.value = storedSubjectTitle;
      if (typeof below === 'undefined') {
        // 初始化
        // 用名字查找所在关卡是第几关
        const indexObj = findNumberPosition(subjectTitleCopy.value, subjectList);
        // 关卡题目值
        subject.value = subjectList[indexObj.row][indexObj.column] || {};
        if (data !== undefined) {
          const list = JSON.parse(localStorage.getItem('levelList'));
          const obj = getIndex(levelList, storedSubjectTitle);
          list[obj.objectIndex].current = 11;
          localStorage.setItem('levelList', JSON.stringify(list));
        }
      }
      if (typeof below !== 'undefined') {
        // 下一关
        const obj = getIndex(levelList, storedSubjectTitle);
        const nextSubjectTitle = levelList[obj.objectIndex].level[obj.nameIndex + 1];
        subjectTitleCopy.value = nextSubjectTitle.replace(/<br\/>/g, '').concat();
        localStorage.setItem('groupListName', nextSubjectTitle);
        const indexObj = findNumberPosition(nextSubjectTitle.replace(/<br\/>/g, ''), subjectList);
        subject.value = subjectList[indexObj.row][indexObj.column] || {};
        // 更新关卡索引
        levelListIndex = obj.objectIndex; // 更新关卡索引到下一个关卡
        // smallLevelIndexCopy.value = levelListIndex
        localStorage.setItem('groupListIndex', Number(groupListIndex) + 1);
        const list = JSON.parse(localStorage.getItem('levelList'));
        list[obj.objectIndex].approve[obj.nameIndex] = true;
        list[obj.objectIndex].current = list[obj.objectIndex].current > obj.nameIndex ? list[obj.objectIndex].current : obj.nameIndex;
        localStorage.setItem('levelList', JSON.stringify(list));
        props.getLevel();
      }
      if (subject.value && subject.value.answerList && subject.value.answerList.length !== 0) {
        const answerList = subject.value.answerList.map(i => ({
          ...i,
          correct: 0
        }));
        const answerCardList = JSON.parse(localStorage.getItem('answerCardList')) || [];
        // 错误答案
        removeErrorCard.value = removeDuplicates(answerList, answerCardList);
        const card = answerList.length > 2 ? answerList.slice(0, 2) : answerList;
        // 从原始数组中随机选择两个对象并推送到新数组中
        for (let i = 0; i < 2; i++) {
          // 生成一个随机索引
          const randomIndex = Math.floor(Math.random() * removeErrorCard.value.length);
          // 从原始数组中取出对象
          const randomObject = removeErrorCard.value[randomIndex];
          // 将对象推送到新数组中
          card.push(randomObject);
          // 从原始数组中删除该对象
          removeErrorCard.value.splice(randomIndex, 1);
        }
        answerCard.value = card;
      }
    }
    onMounted(() => {
      // 延迟执行初始化函数
      initialize(undefined);
      smallLevelIndexCopy.value = Number(localStorage.getItem('groupListIndex'));
    });

    // 比较函数，用于检查两个对象的 imgFrontRes 是否相等
    function compareObjects(obj1, obj2) {
      return obj1.imgFrontRes === obj2.imgFrontRes;
    }
    function removeDuplicates(arr1, arr2) {
      const newArray = [];
      // 遍历后一个数组
      for (let i = 0; i < arr2.length; i++) {
        // 查找后一个数组中的对象是否存在于前一个数组中
        const found = arr1.some(obj => compareObjects(obj, arr2[i]));
        // 如果没找到相等的对象，则将该对象添加到新数组中
        if (!found) {
          newArray.push(arr2[i]);
        }
      }
      return newArray;
    }
    function findIndexByName(name, data) {
      // 遍历数组
      if (data) {
        for (let i = 0; i < data.length; i++) {
          // 在当前对象的 "index" 数组中查找名字
          const index = data[i].index.findIndex(item => item === name);
          // 如果找到了，返回当前对象的位置
          if (index !== -1) {
            return i;
          }
        }
        // 如果没找到，返回 -1
        return -1;
      }
      return -1;
    }

    // 查找名字
    function findNumberPosition(num, list) {
      for (let i = 0; i < list.length; i++) {
        const sublist = list[i];
        for (let j = 0; j < sublist.length; j++) {
          const indexArr = sublist[j].index;
          if (indexArr.includes(num)) {
            return {
              row: i,
              column: j,
              index: indexArr.indexOf(num)
            };
          }
        }
      }
      return null; // 如果未找到数字，则返回 null
    }

    // 轮播图相关
    function next() {
      if (showCard.value < answerCard.value.length - 1) {
        showCard.value++;
      }
    }
    function prev() {
      if (showCard.value > 0) {
        showCard.value--;
      }
    }
    function handleBack() {
      indicate.value = !indicate.value;
    }

    // 查看轮播图
    function handleViewCarousel(index) {
      carouselShow.value = true;
      showCard.value = index;
    }

    // 关闭轮播图
    function handleTurnOffCarousel() {
      carouselShow.value = false;
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", {
        class: "answer-box",
        onDragover: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
      }, [_createElementVNode("div", _hoisted_1, [_withDirectives(_createElementVNode("div", {
        class: _normalizeClass('dialog-box' + __props.arrangeNum)
      }, [_createElementVNode("div", {
        class: "dialog-title",
        style: _normalizeStyle({
          'color': __props.arrangeNum === 0 ? '#FF017B' : __props.arrangeNum === 1 ? '#06D9B4' : __props.arrangeNum === 2 ? '#FFB600' : __props.arrangeNum === 3 ? '#D1AFFF' : ''
        })
      }, _toDisplayString(subjectTitleCopy.value), 5), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, _toDisplayString(subject.value.title || ''), 1), _createTextVNode(" " + _toDisplayString(subject.value.expound || ''), 1)])], 2), [[_vShow, answerStatus.value === null]]), _withDirectives(_createElementVNode("div", {
        class: _normalizeClass('dialog-answer' + __props.arrangeNum)
      }, " 答案正确，你真棒！ ", 2), [[_vShow, answerStatus.value !== null && answerStatus.value === 0]]), _withDirectives(_createElementVNode("div", {
        class: _normalizeClass('dialog-answer' + __props.arrangeNum)
      }, " 答案错误，再思考一下吧 ", 2), [[_vShow, answerStatus.value !== null && answerStatus.value === 1]]), _withDirectives(_createElementVNode("div", {
        class: _normalizeClass(['dialog-answer' + __props.arrangeNum, 'dialog-answer-no'])
      }, [_createTextVNode(" 答案错误，"), _hoisted_3, _createTextVNode("没有备选答案了，再思考一下吧 ")], 2), [[_vShow, answerStatus.value !== null && answerStatus.value === 2]]), _createElementVNode("img", {
        class: _normalizeClass(__props.arrangeNum === 0 ? 'judge0' : __props.arrangeNum === 1 ? 'judge1' : __props.arrangeNum === 2 ? 'judge2' : 'judge3'),
        src: require(`@/assets/images/game/answer/character${__props.arrangeNum === null ? 0 : __props.arrangeNum}.png`),
        alt: "",
        draggable: "false"
      }, null, 10, _hoisted_4)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
        class: "img",
        src: require(`@/assets/images/game/answer/television${__props.arrangeNum === null ? 0 : __props.arrangeNum}.png`),
        alt: "",
        draggable: "false"
      }, null, 8, _hoisted_7), _createElementVNode("div", {
        class: _normalizeClass(['frame', answerStatus.value !== null && answerStatus.value === 1 ? 'error-frame' : answerStatus.value !== null && answerStatus.value === 0 ? `correct-frame${__props.arrangeNum !== null ? __props.arrangeNum : 0}` : ''])
      }, [_createElementVNode("img", {
        class: "doubleImg",
        src: require(`@/assets/images/game/levelCard2/0${__props.arrangeNum + 1}-${smallLevelIndexCopy.value + 1}.png`),
        alt: "",
        draggable: "false"
      }, null, 8, _hoisted_8)], 2), _createElementVNode("div", {
        class: "small-window",
        onDragover: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
        onDrop: onDrop
      }, [_createElementVNode("div", {
        class: _normalizeClass(['nomenclature', 'auto-wrap', answerStatus.value !== null && answerStatus.value === 1 ? `error-text` : answerStatus.value !== null && answerStatus.value === 0 ? `correct-text${__props.arrangeNum !== null ? __props.arrangeNum : 0}` : ''])
      }, [_createElementVNode("span", null, _toDisplayString(droppedAnswer.value), 1)], 2)], 32), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", {
        class: _normalizeClass(['button', !droppedAnswer.value ? 'buttonColor' : `correct-frame${__props.arrangeNum !== null ? __props.arrangeNum : 0}`]),
        onClick: handleConfirm
      }, _hoisted_11, 2)])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createVNode(_TransitionGroup, {
        name: "fade"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(answerCard.value, (i, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: "answer-list",
            key: index,
            onDragstart: $event => onDragStart(i, index),
            draggable: "true"
          }, [_createElementVNode("div", _hoisted_15, [_withDirectives(_createElementVNode("img", {
            class: _normalizeClass(['answer-card', errorIndex.value === index ? 'cardAdmission' : '']),
            onClick: $event => handleViewCarousel(index),
            src: require(`@/assets/images/game/algorithmCard/${i.imgFrontRes}.png`),
            alt: "",
            draggable: "true"
          }, null, 10, _hoisted_16), [[_vShow, index !== dragCardIndex.value]])]), _createElementVNode("div", _hoisted_17, [_createElementVNode("img", {
            class: "baseImg",
            src: require(`@/assets/images/game/answer/base${__props.arrangeNum === null ? 0 : __props.arrangeNum}.png`),
            alt: "",
            draggable: "false"
          }, null, 8, _hoisted_18)])], 40, _hoisted_14);
        }), 128))]),
        _: 1
      })])])])], 32), _withDirectives(_createElementVNode("div", _hoisted_19, [_createElementVNode("div", {
        class: "exit-box"
      }, [_createElementVNode("img", {
        class: "exitButton",
        onClick: handleTurnOffCarousel,
        src: _imports_1,
        alt: "",
        draggable: "false"
      })]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("img", {
        class: "arrow",
        onClick: prev,
        src: _imports_2,
        alt: "",
        draggable: "false"
      }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(answerCard.value, (i, index) => {
        return _withDirectives((_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["card", {
            active: currentIndex.value === index
          }]),
          key: index
        }, [_createElementVNode("div", _hoisted_22, [indicate.value ? (_openBlock(), _createElementBlock("div", _hoisted_23, [_createElementVNode("img", {
          class: "front-img",
          src: require(`@/assets/images/game/algorithmCard/${i.imgFrontRes}.png`),
          alt: "",
          draggable: "false"
        }, null, 8, _hoisted_24), _createElementVNode("div", {
          class: "front-back-buttons"
        }, [_hoisted_25, _createElementVNode("img", {
          class: "cardReverse",
          onClick: handleBack,
          src: _imports_4,
          alt: "",
          draggable: "false"
        })])])) : _createCommentVNode("", true), !indicate.value ? (_openBlock(), _createElementBlock("div", _hoisted_26, [_createElementVNode("img", {
          class: "front-img",
          src: require(`@/assets/images/game/algorithmCard/${i.imgFrontRes}.1.png`),
          alt: "",
          draggable: "false"
        }, null, 8, _hoisted_27), _createElementVNode("div", {
          class: "front-back-buttons"
        }, [_createElementVNode("img", {
          class: "cardReverse",
          onClick: handleBack,
          src: _imports_4,
          alt: "",
          draggable: "false"
        }), _hoisted_28])])) : _createCommentVNode("", true)])], 2)), [[_vShow, index === showCard.value]]);
      }), 128)), _createElementVNode("img", {
        class: "arrow",
        onClick: next,
        src: _imports_5,
        alt: "",
        draggable: "false"
      })])])], 512), [[_vShow, carouselShow.value]]), _withDirectives(_createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_hoisted_31, _createElementVNode("div", _hoisted_35, [_createElementVNode("img", {
        class: "homeBtn",
        src: _imports_10,
        alt: "",
        onClick: goHome,
        draggable: "false"
      }), _withDirectives(_createElementVNode("img", {
        class: "nextLevelBtn",
        src: _imports_11,
        alt: "",
        onClick: nextLevel,
        draggable: "false"
      }, null, 512), [[_vShow, !hideNext.value]])])])], 512), [[_vShow, clearanceShow.value]])]);
    };
  }
};